import { sortByCreateTime } from "@/assets/utils/unit";
import Api from "@/components/Api/index";
import OrderApi from "@/components/Api/order";
import { debounce } from "@/assets/utils/unit";

export const OrderMinxin = {
  methods: {
    debounceOrderList: debounce(function () {
      this.orderList();
    }, 2000),
    //替换页面数据方法
    unpdateData(data) {
      if (data.brushPosition === "ORDER_LIST") {
        this.debounceOrderList();
      } else {
        let datas = this.listDatas.find(
          (n) => n.orderChildrenId == data.childrenId
        );
        if (datas) {
          datas.truncationResult.opButtonResultList = data.opButtonResultList;
          datas.truncationResult.opLogResults = sortByCreateTime(
            data.opLogResults
          );
          datas.truncationResult.statusResultList = data.statusResultList;
          datas.truncationResult.seconds = data.seconds ? data.seconds : null;
          datas.truncationResult.lock = data.lock;
        }
      }
    },
    update(methodsNums) {
      //触发这个参数的方法
      if (this[methodsNums]) {
        this[methodsNums]();
      } else {
        alert("暂未开发");
      }
    },
    viewRefundInformation() {
      this.$refs.confirmFeesAndCancelOrders.initClick(this.allDatas.orderChildrenId,false);
    },
    //修改订单
    modifyOrder() {
      this.$refs.cancelOrderPopup.initClick();
    },
    //我的询单
    myInquiry() {
      alert("我的询单");
    },
    //查看询单
    viewInquiry() {
      this.$refs.inquiryDetailsPopup.initClick();
    },
    //查看已提交询单
    viewsubmittedInouiries() {
      alert("查看已提交询单");
    },
    //查看客户询单
    viewCustomerInquiries() {
      alert("查看客户询单");
    },

    //订单取消
    cancelOrder() {
      this.$confirm("您是否取消订单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          new OrderApi("order")
            .orderPartHasBeenPaidAndCancelled1(this.orderChildrenId)
            .then((res) => {
              if (res.status == 200) {
                this.$message({
                  type: "success",
                  message: "已成功取消订单!",
                });
              } else {
                this.$message({ type: "error", message: res.statusText });
              }
            });
        })
        .catch(() => {});
    },
    totalPrice(arr) {
      let price = 0;
      arr.forEach((n) => {
        price += n.price * n.number * n.rate;
      });
      return price.toFixed(2);
    },
    //支付后订单取消 || 订单变更
    payCancelOrder() {
      // this.$refs.orderCancellationPopup.initClick(this.allDatas.orderChildrenId)
      this.$refs.confirmFeesAndCancelOrders.initClick(
        this.allDatas.orderChildrenId
      );
    },
    viewReplies() {
      this.$refs.confirmFeesAndCancelOrders.initClick(
        this.allDatas.orderChildrenId
      );
    },
    //点评
    comment() {
      this.$refs.remarkPopup.init(this.allDatas);
    },
    //打开调整订单金额弹框
    adjustOrderContentAndAmount() {
      this.$refs.modifyTable.dialogVisible = true;
    },
    //默认好评
    defaultPositiveReviews() {
      this.$refs.remarkPopup.init(this.allDatas, "默认好评");
    },
    //查看我的点评
    viewComments() {
      new Api("resource").viewComments(this.orderChildrenId).then((res) => {
        if (res.status == 200) {
          this.$refs.remarkPopup.init(res.data);
        } else {
          this.$message.error({ message: res.statusText });
        }
      });
    },
    //付款
    orderPay() {
      if (this.allDatas.parentId) {
         this.$emit('openPay', [this.allDatas.orderChildrenId])
      } else {
        this.$refs.staticPayTable.init(this.orderMainId);
      }
    },
    //再次预定
    reorder() {
      if (this.allDatas.orderInquiryId > 0) {
        this.viewInquiry();
      } else {
        this.$refs.createPreOrder.init([this.allDatas.budgetId], 0);
      }
    },
  },
};
